export const actionsFilterTokens = {
    standard: 'standard',
    ghost: 'ghost',
    orphan: 'orphan',
};

const filterOptionOrder = [
    actionsFilterTokens.standard,
    actionsFilterTokens.ghost,
    actionsFilterTokens.orphan,
];

const getActionTokensFromFlags = ({ isGhost, isOrphan }) => {
    if (!isGhost && !isOrphan) {
        return [actionsFilterTokens.standard];
    }

    const tokens = [];

    if (isGhost) {
        tokens.push(actionsFilterTokens.ghost);
    }

    if (isOrphan) {
        tokens.push(actionsFilterTokens.orphan);
    }

    return tokens;
};

export const getActionsFilterValues = rowData => {
    if (!rowData?.promotionId) {
        return [];
    }

    return getActionTokensFromFlags(rowData);
};

export const matchesActionsFilterTokens = ({ promotion, selectedTokens = [] }) => {
    if ((!promotion?._id && !promotion?.promotionId) || !selectedTokens.length) {
        return false;
    }

    const promotionTokens = getActionTokensFromFlags(promotion);

    return promotionTokens.some(token => selectedTokens.includes(token));
};

export const getActionsFilterOptions = ({ includeGhostPromotions }) => {
    return filterOptionOrder.filter(
        token => includeGhostPromotions || token !== actionsFilterTokens.ghost
    );
};

export const sanitizeActionsFilterValues = ({ values = [], includeGhostPromotions }) => {
    const allowedValues = new Set(getActionsFilterOptions({ includeGhostPromotions }));
    const sanitizedValues = values.filter(value => allowedValues.has(value));

    return sanitizedValues.length ? sanitizedValues : [actionsFilterTokens.standard];
};
